import React from 'react';
import { ITextInputProps } from './ITextInputProps'

const TextInput: React.FC<ITextInputProps> = ({ label, name, placeholder, value, updateInput }) => {

   const checkMinMax = (e: React.ChangeEvent<HTMLInputElement>) => {
      const val = parseInt(e.target.value, 10)
      if (val < parseInt(e.target.min, 10)) {
         e.target.value = e.target.min
         updateInput(e)
      }
      if (val > parseInt(e.target.max, 10)) {
         e.target.value = e.target.max
         updateInput(e)
      }
   }

   return (
      <div className='text-input-container'>
         <label className="text-input-label">
            <span className="text-input-label-span">{label}</span>
            <input
               type="text"
               name={name}
               className="text-input border"
               placeholder={placeholder}
               value={value}
               onChange={(e) => { updateInput(e) }}
               onBlur={(e) => { checkMinMax(e) }}
            />
         </label>
      </div>
   );
};

export default TextInput;
